import { useEffect, useState } from 'react';

import type { FilteredColorsData } from 'src/modules/designStudio/machines/productCatalog/types';
import {
  createDoorCatalog,
  emptyCatalog,
} from 'src/modules/designStudio/providers/ProductCatalogProvider/doors';
import type { DoorCatalog } from 'src/modules/designStudio/providers/ProductCatalogProvider/doors/types';
import { useGetDoorProductsQuery } from 'src/shared/graphql/generated';

export const useDoorCatalog = (filteredColors?: FilteredColorsData) => {
  const [doorCatalog, setDoorCatalog] = useState<DoorCatalog>(emptyCatalog);
  const { data: doors } = useGetDoorProductsQuery({});
  useEffect(() => {
    if (doors && filteredColors) {
      setDoorCatalog(createDoorCatalog(doors, filteredColors));
    }
  }, [doors, filteredColors]);
  return doorCatalog;
};
